import { formatRecordingDuration } from "../utils/recordingMediaUtils";
import { RetailRecordingStatus } from "../types";
import {
  FloatingContainer,
  Pill,
  PillLabel,
  RecordingDot,
  StopButton,
  TimerText,
} from "./styles";

type RecordingFloatingIndicatorProps = {
  status: Extract<
    RetailRecordingStatus,
    "recording" | "recording_follower" | "stopping"
  >;
  elapsedSeconds: number;
  onStop: () => void;
};

// Persistent bottom-left indicator shown whenever a recording is active for
// the day, whether this tab is the one actually capturing audio ("recording")
// or another tab is ("recording_follower").
const RecordingFloatingIndicator = ({
  status,
  elapsedSeconds,
  onStop,
}: RecordingFloatingIndicatorProps) => {
  const isStopping = status === "stopping";
  const isFollower = status === "recording_follower";

  return (
    <FloatingContainer>
      <Pill role="group" aria-label="Recording in progress">
        <RecordingDot dim={isStopping} />
        {isFollower ? (
          <PillLabel>Recording active in another tab</PillLabel>
        ) : (
          <TimerText>{formatRecordingDuration(elapsedSeconds)}</TimerText>
        )}
        <StopButton
          aria-label={isStopping ? "Stopping recording" : "Stop recording"}
          disabled={isStopping}
          onClick={onStop}
          type="button"
        >
          {isStopping ? "Stopping..." : "Stop"}
        </StopButton>
      </Pill>
    </FloatingContainer>
  );
};

export { RecordingFloatingIndicator };
